import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { NvDesignLibraryModule } from '../../../../nvps-libraries/design/nv-design-library.module';
import { BaseModalModule } from '../base-modal.module';
import { RemoveStudentActivityModalComponent } from './remove-student-activity/remove-student-activity-modal.component';
import { StudentActivitiesModalComponent } from './student-activities-modal.component';
import { StudentActivityModalHelpersService } from './student-activity-modal-helpers.service';
import { StudentActivityStatusModalComponent } from './student-activity-status/student-activity-status-modal.component';

@NgModule({
  declarations: [
    StudentActivitiesModalComponent,
    StudentActivityStatusModalComponent,
    RemoveStudentActivityModalComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatOptionModule,
    FormsModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    BaseModalModule,
    MatMenuModule,
    NvDesignLibraryModule,
  ],
  exports: [StudentActivitiesModalComponent, StudentActivityStatusModalComponent, RemoveStudentActivityModalComponent],
  providers: [StudentActivityModalHelpersService],
  entryComponents: [
    StudentActivitiesModalComponent,
    StudentActivityStatusModalComponent,
    RemoveStudentActivityModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StudentActivitiesModalModule {}
